// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { ADD_BILL_METHODS } from '../consts';
import StripAction from '../../../../../components/StripAction';
import TitleBadge from '../../../../../components/TitleBadge';

interface IProps {
    onStripClick: (type: string) => void;
}

export const StripActionsList = ({ onStripClick }: IProps) => {
  const { t } = useTranslation();
  return (
    <div className='w-[480px] max-w-[480px] flex flex-col gap-[16px]'>
      {ADD_BILL_METHODS.map(({
        title,
        type,
        IconAsset,
        content,
        badge,
      }) => (
        <StripAction
          key={type}
          title={t(title)}
          actionType={type}
          onActionClick={() => onStripClick(type)}
          icon={<IconAsset />}
          subTitle={t(content)}
          badge={badge ? <TitleBadge title={t(badge.title)} colorSchemeId={badge.scheme} /> : null}
        />
      ))}
    </div>
  );
};
